import React, { Fragment } from 'react'

import { StaticQuery, graphql } from 'gatsby'

import 'modern-normalize/modern-normalize.css'
import '../../../styles/globalStyles.scss'
import Meta from '../Meta'

export default ({ children, meta, title, alternateOgImage }) => {
  return (
    <StaticQuery
      query={graphql`
        query IndexLayoutQuery {
          settingsYaml {
            siteTitle
            siteDescription
            googleTrackingId
          }
        }
      `}
      render={(data) => {
        const { siteTitle, socialMediaCard, googleTrackingId } =
          data.settingsYaml || {}

        return (
          <Fragment>
            <Meta
              googleTrackingId={googleTrackingId}
              defaultTitle={title}
              {...meta}
              alternateOgImage={alternateOgImage}
            />
            <Fragment>{children}</Fragment>
          </Fragment>
        )
      }}
    />
  )
}
